import React from 'react';

import { Container } from './styles'

function Certidoes() {
  return (
    <Container>
      <section>
        <br/>
        <h1>NOSSAS CERTIDÕES</h1>
        <br/>
        <p>Caso precise de nossas certidões para processos municipais ou estaduais, basta clicar nos butões abaixo
          para acessá-los. Em caso de dúvidas, basta entrar em contato pelo (62) 99609-0413 ou enviar para contato@expoprev.com.br.
        </p>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/06/Certidão-negativa-de-falência-concordata-ou-recuperação-judicial-TJGO.pdf' target='_blank' rel="noreferrer">
          <button>Certidão Negativa de Falência</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/06/ESTADUAL-03-07-2022.pdf' target='_blank' rel="noreferrer">
          <button>Certidão Estadual</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/06/FGTS-24-06-2022.pdf' target='_blank' rel="noreferrer">
          <button>Certidão FGTS</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/06/MUNICIPAL-31-07-2022.pdf' target='_blank' rel="noreferrer">
          <button>Certidão Municipal</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/06/TRABALHISTA-30-07-2022.pdf' target='_blank' rel="noreferrer">
          <button>Certidão Trabalhista</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/06/UNIГO-29-11-2022.pdf' target='_blank' rel="noreferrer">
          <button>Certidão União</button>
        </a>
        <br/>
        <br/>
      </section>
      <br/>
    </Container>
  );
}

export default Certidoes;